import { Fragment, ReactNode } from "react";
import { GameVer } from "~/util/Lang";
import S from "./NotFoundInfo.module.css";

export function NotFoundInfo(props: {
  title: string;
  altsTitle: string;
  alts: Array<{ gver: GameVer; node: ReactNode }>;
}) {
  return (
    <div className={S.root}>
      <h2 className={S.title}>{props.title}</h2>

      {props.alts.length > 0 && (
        <Fragment>
          <div className={S.altsTitle}>{props.altsTitle}</div>
          <ul>
            {props.alts.map((alt, i) => {
              return (
                <li key={i}>
                  <span className={S.gver}>{alt.gver.toUpperCase()}</span>{" "}
                  {alt.node}
                </li>
              );
            })}
          </ul>
        </Fragment>
      )}
    </div>
  );
}
